import { createAction, props } from '@ngrx/store';

//get All my project List
export const getAllMyProjectList = createAction(
  '[Projects/API] get my all project list',
  props<{ myProjectListPaylaod: any }>()
);
export const getAllMyProjectListSuccess = createAction(
  '[Projects/API] get my all project list success',
  props<{ myAllProjectsList: any }>()
);
export const getAllMyProjectListFailure = createAction(
  '[Projects/API] get my all project list failure',
  props<{ error: any }>()
);
//get All my product project List
export const getProductIngredientList = createAction(
  '[Projects/API] get my all product ingredient project list',
  props<{ productId: any; myProductIngredientListPaylaod: any }>()
);
export const getProductIngredientListSuccess = createAction(
  '[Projects/API] get my all product ingredient project list success',
  props<{ productIngredientList: any }>()
);
export const getProductIngredientListFailure = createAction(
  '[Projects/API] get my all product ingredient project list failure',
  props<{ error: any }>()
);
//get All my product manufacture List
export const getProductManufactureList = createAction(
  '[Projects/API] get my all product manufacture project list',
  props<{ productId: any; myProductManufactureListPaylaod: any }>()
);
export const getProductManufactureListSuccess = createAction(
  '[Projects/API] get my all product manufacture project list success',
  props<{ productManufactureList: any }>()
);
export const getProductManufactureListFailure = createAction(
  '[Projects/API] get my all product manufacture project list failure',
  props<{ error: any }>()
);
//get All my product project List
export const getAllMyProductProjectList = createAction(
  '[Projects/API] get my all product project list',
  props<{ myProductProjectListPaylaod: any }>()
);
export const getAllMyProductProjectListSuccess = createAction(
  '[Projects/API] get my all product project list success',
  props<{ myAllProductProjectsList: any }>()
);
export const getAllMyProductProjectListFailure = createAction(
  '[Projects/API] get my all product project list failure',
  props<{ error: any }>()
);
//Action for opening add/edit  my project List
export const openAllMyProjectModal = createAction(
  '[Projects/API] Open  All Project',
  props<{ projectId?: any; actionLabel: any; pathName: any }>()
);
export const openAllMyProjectModalSuccess = createAction(
  '[Projects/API] Open  All Project Modal success',
  props<{ openAllMyProjectModalData?: any }>()
);
//Action for copying my project modal
export const allMyProjectCopyModal = createAction(
  '[Projects/API] allMyProjectCopyModal',
  props<{ action: any; actionLabel: any; pathName: any }>()
);
export const allMyProjectCopyModalSuccess = createAction(
  '[Projects/API] allMyProjectCopyModal Success',
  props<{ copyModalData: any }>()
);
export const clearMyProjectCopy = createAction('[Projects/API] clear My  Projects copy process');
//Action for delete Data my project open sweet-alert
export const deleteDataMyProject = createAction(
  '[Projects/API] deleteDataMyProject',
  props<{ action: any; pathName: any; pageName?: any }>()
);
// Action for delete my project
export const deleteMyProjectData = createAction(
  '[Projects/API] deleteMyProjectData',
  props<{ payload: any; pathName: any }>()
);
export const deleteMyProjectDataSuccess = createAction(
  '[Projects/API] deleteMyProjectData Success',
  props<{ deleteMyProjectDataMessage: any }>()
);
export const deleteMyProjectDataFailure = createAction(
  '[Projects/API] deleteMyProjectData Failure',
  props<{ error: any }>()
);
//add edit my project
export const addEditMyProject = createAction(
  '[Projects/API] Add edit my project ',
  props<{ myProjectDataPayload: any; isEdit?: any }>()
);
export const addEditMyProjectSuccess = createAction(
  '[Projects/API] Add edit my project  success',
  props<{ myProjectData: any }>()
);
export const addEditMyProjectFailure = createAction(
  '[Projects/API] Add edit my project  failure',
  props<{ error: any }>()
);
//add edit my project
export const addEditMyProductProject = createAction(
  '[Projects/API] Add edit my product project ',
  props<{ myProductProjectDataPayload: any }>()
);
export const addEditMyProductProjectSuccess = createAction(
  '[Projects/API] Add edit my product project  success',
  props<{ myProductProjectData: any }>()
);
export const addEditMyProductProjectFailure = createAction(
  '[Projects/API] Add edit my product project  failure',
  props<{ error: any }>()
);
//add copy my project
export const copyMyProject = createAction(
  '[Projects/API] copy my project ',
  props<{ copyMyProjectDataPayload: any }>()
);
export const copyMyProjectSuccess = createAction(
  '[Projects/API] copy my project  success',
  props<{ copyMyProjectData: any }>()
);
export const copyMyProjectFailure = createAction(
  '[Projects/API] copy my project  failure',
  props<{ error: any }>()
);
//Action for adding project material
export const newMyProjectAction = createAction(
  '[Projects/API]  new Add my project',
  props<{ newMaterialData: any; action: any; ingredientIndex?: any }>()
);
export const newMyProjectActionSuccess = createAction(
  '[Projects/API]  new Add my project Success',
  props<{ newDefalutMaterialList: any; errorMessage?: any }>()
);
export const newMyProjectActionFailure = createAction(
  '[Projects/API]  new Add my project Failure',
  props<{ error: any }>()
);
export const clearNewMyProjectAction = createAction('[Projects/API] clear  new Add my project');

//get All my project scenario List
export const getAllMyProjectScenarioList = createAction(
  '[Projects/API] get my all project scenario list',
  props<{ myProjectListPaylaod: any; projectId: any; scenarioTypeId: any }>()
);
export const getAllMyProjectScenarioListSuccess = createAction(
  '[Projects/API] get my all project scenario list success',
  props<{ myAllProjectsScenarioList: any }>()
);
export const getAllMyProjectScenarioListFailure = createAction(
  '[Projects/API] get my all project scenario list failure',
  props<{ error: any }>()
);

//Action for opening add/edit  my project scenario List
export const openAllMyProjectScenarioModal = createAction(
  '[Projects/API] Open  openAllMyProjectScenarioModal',
  props<{ scenarioId?: any; actionLabel: any; scenarioTypeId: any; projectId: any }>()
);
export const openAllMyProjectScenarioModalSuccess = createAction(
  '[Projects/API] Open  openAllMyProjectScenarioModal success',
  props<{ openAllMyProjectScenarioModalData?: any }>()
);

//Action for opening add/edit  my project scenario Material List
export const openNewAddProjectMaterialModal = createAction(
  '[Projects/API] Open  openNewAddProjectMaterialModal',
  props<{ scenarioId?: any; actionLabel: any; isMaterial: boolean; id: any; pathName: any }>()
);
export const openNewAddProjectMaterialModalSuccess = createAction(
  '[Projects/API] Open  openNewAddProjectMaterialModalsuccess',
  props<{ openNewAddProjectMaterialModalData?: any }>()
);

//Action for opening product ingredient main modal
export const openAddEditMyProductProjectModal = createAction(
  '[Projects/API] Open  All product Project',
  props<{ productId: any; actionLabel: any; pathName: any }>()
);
export const openAddEditMyProductProjectModalSuccess = createAction(
  '[Projects/API] Open  All Project product Modal success',
  props<{ openAllMyProductProjectModalData?: any }>()
);
//Action for opening product ingredient child modal
export const openModalProductIngredientModal = createAction(
  '[Projects/API] Open  openModalProductIngredientModal',
  props<{ productId: any; actionLabel: any; id: any; pathName: any }>()
);
export const openModalProductIngredientModalSuccess = createAction(
  '[Projects/API] Open  openModalProductIngredientModalSuccess',
  props<{ openModalProductIngredientModalData?: any }>()
);

//Action for opening add/edit  my project scenario Manufacture List
export const openNewAddProjectManufactureModal = createAction(
  '[Projects/API] Open  openNewAddProjectManufactureModal',
  props<{ scenarioId?: any; actionLabel: any; scenarioTypeId: any; projectId: any }>()
);
export const openNewAddProjectManufactureSuccess = createAction(
  '[Projects/API] Open  openNewAddProjectManufactureSuccess',
  props<{ openNewAddProjectManufactureModalData?: any }>()
);

//get All my project scenario consumer List
export const getAllMyProjectScenarioConsumerList = createAction(
  '[Projects/API] get my all project scenario consumer list',
  props<{
    myProjectScenarioConsumerListPaylaod: any;
    storagetypeId: any;
    scenarioId: any;
    projectId: any;
  }>()
);
export const getAllMyProjectScenarioConsumerListSuccess = createAction(
  '[Projects/API] get my all project scenario consumer list success',
  props<{ myAllProjectsScenarioConsumerList: any }>()
);
export const getAllMyProjectScenarioConsumerListFailure = createAction(
  '[Projects/API] get my all project scenario consumer list failure',
  props<{ error: any }>()
);

//get All my project scenario Wholesale List
export const getAllMyProjectScenarioWholesaleList = createAction(
  '[Projects/API] get my all project scenario Wholesale list',
  props<{
    myProjectScenarioWholesaleListPaylaod: any;
    storagetypeId: any;
    scenarioId: any;
    projectId: any;
  }>()
);
export const getAllMyProjectScenarioWholesaleListSuccess = createAction(
  '[Projects/API] get my all project scenario Wholesale list success',
  props<{ myAllProjectsScenarioWholesaleList: any }>()
);
export const getAllMyProjectScenarioWholesaleListFailure = createAction(
  '[Projects/API] get my all project scenario Wholesale list failure',
  props<{ error: any }>()
);

//Add update new scenario
export const addEditScenario = createAction(
  '[Projects/API] Add edit new scenario',
  props<{ scenarioPayload: any }>()
);
export const addEditScenarioSuccess = createAction(
  '[Projects/API] Add edit new scenario success',
  props<{ scenarioData: any; projectId: any; scenarioTypeId: any }>()
);
export const addEditScenarioFailure = createAction(
  '[Projects/API] Add edit new scenario failure',
  props<{ error: any }>()
);

export const deleteProjectData = createAction(
  '[Projects/API] Delete Project scenario',
  props<{ id: any; pathName: any; projectId?: any; scenarioTypeId?: any; pageName?: any }>()
);
export const deleteProjectDataSuccess = createAction(
  '[Projects/API] Delete Project scenario success',
  props<{ deleteMessage: any }>()
);

export const openProjectDeleteModal = createAction(
  '[Projects/API] Delete Modal for Project',
  props<{ id: any; pathName: any; projectId?: any; scenarioTypeId?: any; scenarioId?: any }>()
);

//Action for opening copy for project scenario consumer List
export const openCopyProjectScenario = createAction(
  '[Projects/API] Open copy project scenario consumer',
  props<{ scenarioId: any; actionLabel: any }>()
);
export const openCopyProjectScenarioSuccess = createAction(
  '[Projects/API] Open copy project scenario consumer success',
  props<{ openCopyProjectScenarioModalData?: any }>()
);

//Action for copying project scenario
export const copyScenario = createAction(
  '[Projects/API] copying project scenario',
  props<{ copyScenarioPayload: any }>()
);
export const copyScenarioSuccess = createAction(
  '[Projects/API] copying project scenario success',
  props<{ copyScenarioData: any }>()
);
export const copyScenarioFailure = createAction(
  '[Projects/API] copying project scenario failure',
  props<{ error: any }>()
);
//get All my project pack material List
export const getAllMyProjectPackMaterialList = createAction(
  '[Projects/API] getAllMyProjectPackMaterialList',
  props<{ myProjectListPackMaterialPaylaod: any; scenarioId: any }>()
);
export const getAllMyProjectPackMaterialListSuccess = createAction(
  '[Projects/API] getAllMyProjectPackMaterialListSuccess',
  props<{ myAllProjectsPackMaterialList: any }>()
);
export const getAllMyProjectPackMaterialListFailure = createAction(
  '[Projects/API] getAllMyProjectPackMaterialListFailure',
  props<{ error: any }>()
);
//Actions for project pack material  transport
export const addTransportScenarioForPackMaterial = createAction(
  '[Projects/API] addTransportScenarioForPackMaterial',
  props<{ transport: any; action: any; ingredientIndex?: any }>()
);
export const addTransportScenarioForPackMaterialSuccess = createAction(
  '[Projects/API] addTransportScenarioForPackMaterial Success',
  props<{ transportScenarioList: any; error: any; distanceError: string }>()
);
// pack material distance
export const addTransportScenarioForDistancePackMaterial = createAction(
  '[Projects/API] addTransportScenarioForDistancePackMaterial',
  props<{ transport: any; action: any; ingredientIndex?: any }>()
);
export const addTransportScenarioForDistancePackMaterialSuccess = createAction(
  '[Projects/API] addTransportScenarioForDistancePackMaterial Success',
  props<{ transportScenarioListForDistance: any; error: any }>()
);
export const addPackMaterialConversion = createAction(
  '[Projects/API] addPackMaterialConversion',
  props<{ transport: any; action: any; ingredientIndex?: any }>()
);
export const addPackMaterialConversionSuccess = createAction(
  '[Projects/API] addPackMaterialConversionSuccess Success',
  props<{ conversionList: any; error: any }>()
);
export const clearaddTransportScenarioForPackMaterial = createAction(
  '[Projects/API] clear Projects transport scenario '
);
export const clearaddTransportScenarioForPackMaterialForConversion = createAction(
  '[Projects/API] clear Projects transport scenario conversion '
);
export const clearManualTransportDistanceError = createAction(
  '[Projects/API] clear Projects transport scenario conversion '
);
export const clearConversionListProject = createAction('[Projects/API] clear Projects menusW ');
export const clearaddTransportScenarioForPackMaterialForCustom = createAction(
  '[Projects/API] clear Projects transport scenario for custom'
);
//add edit my project pack material
export const addEditMyProjectPackMaterial = createAction(
  '[Projects/API] Add edit my project pack material ',
  props<{ myProjectDataPayload: any; pathName: any; scenarioId: any }>()
);
export const addEditMyProjectPackMaterialSuccess = createAction(
  '[Projects/API] Add edit my project pack material success',
  props<{ myProjectPackMaterialData: any }>()
);
export const addEditMyProjectPackMaterialFailure = createAction(
  '[Projects/API] Add edit my project pack material failure',
  props<{ error: any }>()
);
//add edit my project product ingredient
export const addEditProductIngredient = createAction(
  '[Projects/API] Add edit my project product ingredient ',
  props<{ myProductIngredientDataPayload: any; pathName: any; productId: any }>()
);
export const addEditProductIngredientSuccess = createAction(
  '[Projects/API] Add edit my project product ingredient success',
  props<{ myProjectProductIngredientData: any }>()
);
export const addEditProductIngredientFailure = createAction(
  '[Projects/API] Add edit my project product ingredient failure',
  props<{ error: any }>()
);
//Action for copying pack material
export const projectPackMaterialCopy = createAction(
  '[Projects/API] projectPackMaterialCopy',
  props<{ action: any; lableName: any; pathName: any; scenarioId: any }>()
);
export const projectPackMaterialCopySuccess = createAction(
  '[Projects/API] projectPackMaterialCopy Success',
  props<{ processList: any }>()
);
export const clearProjectPackMaterialCopy = createAction(
  '[Projects/API] clear projectPackMaterialCopy process'
);
// Action for copy save pack material
export const projectPackMaterialCopySave = createAction(
  '[Projects/API] projectPackMaterialCopySave',
  props<{ payload: any; scenarioId: any; pathName: any }>()
);
export const projectPackMaterialCopySaveSuccess = createAction(
  '[Projects/API] projectPackMaterialCopySave Success',
  props<{ copyProjectPackMaterialDataMessage: any }>()
);
export const projectPackMaterialCopySaveFailure = createAction(
  '[Projects/API] projectPackMaterialCopySave Failure',
  props<{ error: any }>()
);
//get All my project pack conversion List
export const getAllMyProjectPackConversionList = createAction(
  '[Projects/API] getAllMyProjectPackConversionList',
  props<{ myProjectListPackConversionPaylaod: any; scenarioId: any; projectId: any }>()
);
export const getAllMyProjectPackConversionListSuccess = createAction(
  '[Projects/API] getAllMyProjectPackConversionListSuccess',
  props<{ myAllProjectsPackConversionList: any }>()
);
export const getAllMyProjectPackConversionListFailure = createAction(
  '[Projects/API] getAllMyProjectPackConversionListFailure',
  props<{ error: any }>()
);

// Action for Project Filling Data list
export const getProjectFillingList = createAction(
  '[Projects/API] get Project Filling Data',
  props<{ scenarioId: any; projectFillingPayload: any; projectId: any }>()
);
export const getProjectFillingListSuccess = createAction(
  '[Projects/API] get Project Filling Data success',
  props<{ fillingList: any }>()
);
export const getProjectFillingListFailure = createAction(
  '[Projects/API] get Project Filling Data failure',
  props<{ error: any }>()
);

//Action for opening add/edit  my project scenario Fill Data List
export const openNewAddProjectFillDataModal = createAction(
  '[Projects/API] Open add edit project filling',
  props<{ scenarioId?: any; id: any; actionLabel: any; projectId: any }>()
);
export const openNewAddProjectFillDataSuccess = createAction(
  '[Projects/API] Open add edit project filling success',
  props<{ addEditFillingModalData?: any }>()
);

export const addEditProjectFilling = createAction(
  '[Projects/API] Add edit my project filling',
  props<{ fillingPayload: any }>()
);
export const addEditProjectFillingSuccess = createAction(
  '[Projects/API] Add edit my project filling material success',
  props<{ fillingPayload: any }>()
);
export const addEditProjectFillingFailure = createAction(
  '[Projects/API] Add edit my project filling material failure',
  props<{ error: any }>()
);

//Action for adding filling process
export const addFillingProcess = createAction(
  '[Projects/API] filling process',
  props<{ filling: any; action: any }>()
);
export const addFillingProcessSuccess = createAction(
  '[Projects/API] filling process Success',
  props<{ fillingList: any; error: any }>()
);
export const clearaddFillingProcess = createAction('[Projects/API] clear filling process');

//get All my project scenario retail List
export const getAllMyProjectScenarioRetailList = createAction(
  '[Projects/API] get my all project scenario retail list',
  props<{
    myProjectScenarioReatilListPaylaod: any;
    storagetypeId: any;
    scenarioId: any;
    projectId: any;
  }>()
);
export const getAllMyProjectScenarioRetailListSuccess = createAction(
  '[Projects/API] get my all project scenario retail list success',
  props<{ myAllProjectsScenarioReatilList: any }>()
);
export const getAllMyProjectScenarioRetailListFailure = createAction(
  '[Projects/API] get my all project scenario retail list failure',
  props<{ error: any }>()
);
//Action for opening add/edit  my project scenario retail List
export const openNewAddProjectRetaiModal = createAction(
  '[Projects/API] Open  openNewAddProjectRetaiModal',
  props<{ scenarioId?: any; actionLabel: any; storageTypeId: any; id: any; pathName: any }>()
);
export const openNewAddProjectRetaiModalSuccess = createAction(
  '[Projects/API] Open  openNewAddProjectRetaiModalSuccess',
  props<{ openNewAddProjectRetailModalData?: any }>()
);

//Action for adding location process
export const addLocationProcess = createAction(
  '[Projects/API] location process',
  props<{ location: any; action: any }>()
);
export const addLocationProcessSuccess = createAction(
  '[Projects/API] location process Success',
  props<{ locationList: any; replicaLocation: any; error: any; distanceError: string }>()
);
export const clearLocationProcess = createAction('[Projects/API] clear location process');
export const clearAllReplicaList = createAction('[Projects/API] clear replica list');
//Action for adding location process
export const addLocationProcessIngredient = createAction(
  '[Projects/API] addLocationProcessIngredient process',
  props<{ location: any; action: any }>()
);
export const addLocationProcessIngredientSuccess = createAction(
  '[Projects/API] addLocationProcessIngredient Success',
  props<{ locationList: any; replicaLocation: any; error: any; distanceError: string }>()
);
export const clearaddLocationProcessIngredient = createAction(
  '[Projects/API] clear addLocationProcessIngredient process'
);

//Actions for project pack retial  transport
export const addTransportScenarioForPackRetail = createAction(
  '[Projects/API] addTransportScenarioForPackRetail',
  props<{ transport: any; action: any; ingredientIndex?: any }>()
);
export const addTransportScenarioForPackRetailSuccess = createAction(
  '[Projects/API] addTransportScenarioForPackRetail Success',
  props<{ transportScenarioManualLocationList: any; error: any; distanceError: string }>()
);

//pack retail manual distance
export const addTransportScenarioForDistancePackRetail = createAction(
  '[Projects/API] addTransportScenarioForDistancePackRetail',
  props<{ transport: any; action: any; ingredientIndex?: any }>()
);
export const addTransportScenarioForDistancePackRetailSuccess = createAction(
  '[Projects/API] addTransportScenarioForDistancePackRetail Success',
  props<{ retailTransportScenarioListForDistance: any; error: any }>()
);

//add edit my project pack retail
export const addEditMyProjectPackRetail = createAction(
  '[Projects/API] Add edit my project pack retail ',
  props<{ myProjectDataPayload: any; pathName: any; scenarioId: any }>()
);
export const addEditMyProjectPackRetailSuccess = createAction(
  '[Projects/API] Add edit my project pack retail success',
  props<{ myProjectPackRetailData: any }>()
);
export const addEditMyProjectPackRetailFailure = createAction(
  '[Projects/API] Add edit my project pack retail failure',
  props<{ error: any }>()
);
//clear pack retail
export const clearaddTransportScenarioForPackRetail = createAction(
  '[Projects/API] clear Projects transport scenario pack retail '
);
export const clearaddTransportScenarioForPackRetailForCustom = createAction(
  '[Projects/API] clear Projects transport scenario pack retail custom'
);
//eol pack material
export const addPackRetailEol = createAction(
  '[Projects/API] addPackRetailEol',
  props<{ transport: any; action: any; ingredientIndex?: any }>()
);
export const addPackRetailEolSuccess = createAction(
  '[Projects/API] addPackRetailEolSuccess Success',
  props<{ retailEolList: any; error: any }>()
);

// for project filling distance
export const addDistanceTransport = createAction(
  '[Projects/API] filling distance transport process',
  props<{ distance: any; action: any; isDistance?: any }>()
);
export const addDistanceTransportSuccess = createAction(
  '[Projects/API] filling distance transport process Success',
  props<{
    distanceList: any;
    replicaDistanceList: any;
    productIngredientistanceProcessList: any;
    error: any;
  }>()
);
export const clearaddDistanceTransport = createAction(
  '[Projects/API] clear distance transport filling process'
);
// for project filling distance
export const addDistanceTransportIngredeint = createAction(
  '[Projects/API] addDistanceTransportIngredeint',
  props<{ distance: any; action: any; isDistance?: any }>()
);
export const addDistanceTransportIngredeintSuccess = createAction(
  '[Projects/API] addDistanceTransportIngredeint Success',
  props<{
    distanceList: any;
    replicaDistanceList: any;
    productIngredientistanceProcessList: any;
    error: any;
  }>()
);
export const clearaddDistanceTransportIngredeint = createAction(
  '[Projects/API] clear addDistanceTransportIngredeint process'
);

export const getCustomFreight = createAction(
  '[Projects/API] get custom freight',
  props<{ freight?: any; isCustomSiteTransport: any }>()
);
export const getCustomFreightSuccess = createAction(
  '[Projects/API] get custom freight Success',
  props<{ freightList: any }>()
);
export const getCustomFreightFailure = createAction(
  '[Projects/API] get custom freight Failure',
  props<{ error: any }>()
);

export const getCustomFreightForIngredient = createAction(
  '[Projects/API] getCustomFreightForIngredient',
  props<{ freight?: any; isCustomSiteTransport: any }>()
);
export const getCustomFreightForIngredientSuccess = createAction(
  '[Projects/API] getCustomFreightForIngredient Success',
  props<{ freightList: any }>()
);
export const getCustomFreightForIngredientFailure = createAction(
  '[Projects/API] getCustomFreightForIngredient Failure',
  props<{ error: any }>()
);

export const clearCustomFreight = createAction('[Projects/API] clear freight process');
// actions for adding component in project filling
export const addComponent = createAction(
  '[Projects/API] component transport process',
  props<{ component: any; action: any }>()
);
export const addComponentSuccess = createAction(
  '[Projects/API] component transport process Success',
  props<{ componentList: any; error: any }>()
);
export const clearComponent = createAction('[Projects/API] clear component transport process');
export const addComponentCancelled = createAction('[Projects] Add Component Cancelled');

// actions for adding product in project filling
export const addProduct = createAction(
  '[Projects/API] product transport process',
  props<{ product: any; action: any }>()
);
export const addProductSuccess = createAction(
  '[Projects/API] product transport process Success',
  props<{ productList: any; storeerr: any }>()
);
export const clearProduct = createAction('[Projects/API] clear product transport process');

// eol set reset data
export const resetEolData = createAction('[Projects/API] resetEolData');
export const clearTotalEolMessage = createAction('[Projects/API] clearTotalEolMessage');
//Action for opening add/edit  my project scenario consumer List
export const openNewAddProjectScenarioConsumer = createAction(
  '[Projects/API] Open  openNewAddProjectScenarioConsumer',
  props<{ scenarioId?: any; actionLabel: any; id: any; storageTypeId: any; pathName: any }>()
);
export const openNewAddProjectScenarioConsumerSuccess = createAction(
  '[Projects/API] Open  openNewAddProjectScenarioConsumer',
  props<{ openNewAddProjectScenarioConsumerModalData?: any }>()
);

//Action for adding location process for product
export const addLocationProcessProduct = createAction(
  '[Projects/API] location process product ',
  props<{ locationProduct: any; action: any }>()
);
export const addLocationProcessProductSuccess = createAction(
  '[Projects/API] location process Success product ',
  props<{ locationProductList: any; error: any; distanceError: string }>()
);
export const clearaddLocationProcessProduct = createAction(
  '[Projects/API] clear location process product'
);

// for project filling distance for product
export const addDistanceTransportProduct = createAction(
  '[Projects/API] filling distance transport for product process',
  props<{ distanceProduct: any; action: any; isDistance?: any }>()
);
export const addDistanceTransportProductSuccess = createAction(
  '[Projects/API] filling distance transport for product process Success',
  props<{ distanceProductList: any; error: any }>()
);
export const clearaddDistanceProductTransport = createAction(
  '[Projects/API] clear distance transport filling process'
);

export const getCustomFreightProduct = createAction(
  '[Projects/API] get custom freight product',
  props<{ freightProduct?: any; isCustomSiteTransport: any }>()
);
export const getCustomFreightProductSuccess = createAction(
  '[Projects/API] get custom freight product Success',
  props<{ freightProductList: any }>()
);
export const getCustomFreightProductFailure = createAction(
  '[Projects/API] get custom freight product Failure',
  props<{ error: any }>()
);

export const clearCustomFreightProduct = createAction(
  '[Projects/API] clear freight process product'
);

//Action for opening add/edit  my project wholesale Data List
export const openNewAddProjectWholesaleDataModal = createAction(
  '[Projects/API] Open add edit project Wholesale',
  props<{ scenarioId?: any; id: any; storageTypeId: any; actionLabel: any; projectId: any }>()
);
export const openNewAddProjectWholesaleDataSuccess = createAction(
  '[Projects/API] Open add edit project Wholesale success',
  props<{ addEditWholesaleModalData?: any }>()
);

export const addEditProjectWholesale = createAction(
  '[Projects/API] Add edit my project Wholesale ',
  props<{ wholesalePayload: any }>()
);
export const addEditProjectWholesaleSuccess = createAction(
  '[Projects/API] Add edit my project Wholesale success',
  props<{ wholesalePayload: any }>()
);
export const addEditProjectWholesaleFailure = createAction(
  '[Projects/API] Add edit my project Wholesale failure',
  props<{ error: any }>()
);

//Action for adding location for Wholesale
export const addLocationWholesale = createAction(
  '[Projects/API] location for Wholesale process',
  props<{ locationWholesale: any; action: any }>()
);
export const addLocationWholesaleSuccess = createAction(
  '[Projects/API] location for Wholesale process Success',
  props<{ locationWholesaleList: any; error: any; distanceError: string }>()
);
export const clearaddLocationWholesale = createAction(
  '[Projects/API] clear for Wholesale location process'
);

//Action for adding wholesale distance type
export const addDistanceWholesale = createAction(
  '[Projects/API] wholesale distance transport process',
  props<{ wholesaleDistance: any; action: any; isDistance?: any }>()
);
export const addDistanceWholesaleSuccess = createAction(
  '[Projects/API] wholesale distance transport process Success',
  props<{ wholesaleDistanceList: any; error: any }>()
);
export const clearaddDistanceWholesale = createAction(
  '[Projects/API] clear distance transport wholesale process'
);

export const getCustomFreightWholesale = createAction(
  '[Projects/API] get custom freight for wholesale',
  props<{ freightWholesale?: any; isCustomSiteTransport: any }>()
);
export const getCustomFreightWholesaleSuccess = createAction(
  '[Projects/API] get custom freight for wholesale Success',
  props<{ freightWholesaleList: any }>()
);
export const getCustomFreightWholesaleFailure = createAction(
  '[Projects/API] get custom freight for wholesale Failure',
  props<{ error: any }>()
);

export const clearCustomFreightWholesale = createAction(
  '[Projects/API] clear freight wholesale product'
);
//action for add or edit project
export const inlineDataEditForProject = createAction(
  '[Projects/API] Inline Projects  edit',
  props<{ projectInlinePayload: any; scenarioId: any; pathName: any }>()
);
export const inlineDataEditForProjectSuccess = createAction(
  '[Projects/API] Inline Projects  edit success',
  props<{ projectInlineData: any }>()
);
export const inlineDataEditForProjectFailure = createAction(
  '[Projects/API] Inline Projects  edit failure',
  props<{ error: any }>()
);
//action for add or edit project pack material
export const inlineDataEditForProjectMaterial = createAction(
  '[Projects/API] inlineDataEditForProjectMaterial',
  props<{ projectInlinePayload: any; scenarioId: any; pathName: any }>()
);
export const inlineDataEditForProjectMaterialSuccess = createAction(
  '[Projects/API] inlineDataEditForProjectMaterial success',
  props<{ projectMaterialInlineData: any }>()
);
export const inlineDataEditForProjectMaterialFailure = createAction(
  '[Projects/API] inlineDataEditForProjectMaterial failure',
  props<{ error: any }>()
);

//Action for inline add or edit project data
export const inlineEditProject = createAction(
  '[Projects/API] Inline project edit',
  props<{ projectInlineData: any; pathName: any }>()
);
export const inlineEditProjectSuccess = createAction(
  '[Projects/API] Inline project edit success',
  props<{ inlineData: any }>()
);
export const inlineEditProjectFailure = createAction(
  '[Projects/API] Inline project edit failure',
  props<{ error: any }>()
);

// For Project -> Scenario Name
export const inlineEditScenarioName = createAction(
  '[Projects/API] Inline Scenario Name edit',
  props<{ scenarioInlineData: any; pathName: any }>()
);
export const inlineEditScenarioNameSuccess = createAction(
  '[Projects/API] Inline Scenario Name edit success',
  props<{ scenarioData: any }>()
);
export const inlineEditScenarioNameFailure = createAction(
  '[Projects/API] Inline Scenario Name edit failure',
  props<{ error: any }>()
);

//Action for product ingredient action in modal
export const proudctIngredientProcess = createAction(
  '[Projects/API]  proudctIngredientProcess',
  props<{ ingredient: any; action: any; colId?: any; rowId?: any }>()
);
export const proudctIngredientProcessSuccess = createAction(
  '[Projects/API]  proudctIngredientProcess Success',
  props<{ ingredientItems: any; errorMessage: any; columnName?: any }>()
);
export const proudctIngredientProcessFailure = createAction(
  '[Projects/API]  proudctIngredientProcess Failure',
  props<{ error: any }>()
);
export const clearProudctIngredientProcess = createAction(
  '[Projects/API] clear product ingredient '
);
export const clearProudctIngredientProcessError = createAction(
  '[Projects/API] clear product ingredient error '
);

//organization data map

export const organizationDataMapProcess = createAction(
  '[Projects/API]  organizationDataMapProcess',
  props<{ organization: any; action: any; colId?: any; rowId?: any }>()
);
export const organizationDataMapProcessSuccess = createAction(
  '[Projects/API]  organizationDataMapProcess Success',
  props<{ organizationItems: any; errorMessage: any; columnName?: any }>()
);
export const organizationDataMapProcessFailure = createAction(
  '[Projects/API]  organizationDataMapProcess Failure',
  props<{ error: any }>()
);

export const saveOrganizationPreferenceProcess = createAction(
  '[Projects/API]  saveOrganizationPreferenceProcess',
  props<{ payload: any }>()
);
export const saveOrganizationPreferenceProcessSuccess = createAction(
  '[Projects/API]  saveOrganizationPreferenceProcess Success',
  props<{ res: any }>()
);

export const organizationPreferencesDataMapProcess = createAction(
  '[Projects/API]  organizationPreferencesDataMapProcess',
  props<{ organization: any; action: any; colId?: any; rowId?: any }>()
);
export const organizationPreferencesDataMapProcessSuccess = createAction(
  '[Projects/API]  organizationPreferencesDataMapProcessSuccess Success',
  props<{ organizationItems: any; errorMessage: any; columnName?: any }>()
);
export const getOrganizationDataMap = createAction(
  '[Projects/API]  get organization map data',
  props<{ organizationMapList: any }>()
);
export const getOrganizationPreferencesDataMap = createAction(
  '[Projects/API]  get organization preferences map data',
  props<{ organizationPreferencesMapList: any }>()
);

//Action for product ingredient transport action in modal
export const proudctIngredientTransportProcess = createAction(
  '[Projects/API]  proudctIngredientTransportProcess',
  props<{ ingredient: any; action: any }>()
);
export const proudctIngredientTransportProcessSuccess = createAction(
  '[Projects/API]  proudctIngredientTransportProcess Success',
  props<{ ingredientTransportList: any; errorMessage: any }>()
);
export const proudctIngredientTransportProcessFailure = createAction(
  '[Projects/API]  proudctIngredientTransportProcess Failure',
  props<{ error: any }>()
);
//Action for product ingredient manufacture process
export const proudctIngredientManufactureProcess = createAction(
  '[Projects/API]  proudctIngredientManufactureProcess',
  props<{ ingredient: any; action: any }>()
);
export const proudctIngredientManufactureProcessSuccess = createAction(
  '[Projects/API]  proudctIngredientManufactureProcess Success',
  props<{ getManufacturProcessList: any }>()
);
export const proudctIngredientManufactureProcessFailure = createAction(
  '[Projects/API]  proudctIngredientManufactureProcess Failure',
  props<{ error: any }>()
);

// Action for scenario config
export const inlineDataEditForScenarioConfig = createAction(
  '[Projects/API] Inline scenario config edit',
  props<{ scenarioConfigPayload: any; pathName: any }>()
);
export const inlineDataEditForScenarioConfigSuccess = createAction(
  '[Projects/API] Inline scenario config success',
  props<{ scenarioConfigInlineData: any }>()
);
export const inlineDataEditForScenarioConfigFailure = createAction(
  '[Projects/API] Inline scenario config failure',
  props<{ error: any }>()
);
// Action for saving Project Name
export const projectNameForBreadCrumbs = createAction(
  '[Projects/API] store project name',
  props<{ projectName: any }>()
);
export const projectNameForBreadCrumbsSuccess = createAction(
  '[Projects/API] store project name Success',
  props<{ projectName: any }>()
);
export const clearProjectNameForBreadCrumbs = createAction(
  '[Projects/API] clear store project name'
);

export const newMyProjectOrgReporting = createAction(
  '[Projects/API]  new Add organization reporting  project',
  props<{ newOrgReportingData: any; action: any; reportIndex?: any }>()
);
export const newMyProjectOrgReportingSuccess = createAction(
  '[Projects/API]  new Add organization reporting Success',
  props<{ newDefalutOrgReportingList: any; errorMessage?: any }>()
);
export const newMyProjectOrgReportingFailure = createAction(
  '[Projects/API]  new Add organization reporting Failure',
  props<{ error: any }>()
);
export const clearMyProjectOrgReporting = createAction(
  '[Projects/API] clear  new Add organization reporting project'
);
// For Project ->Eol Reuse
export const projectEOLReuseList = createAction(
  '[Projects/API] projectEOLReuseList',
  props<{ payload: any; scenarioId: any }>()
);
export const projectEOLReuseListSuccess = createAction(
  '[Projects/API] projectEOLReuseList success',
  props<{ eolResueList: any }>()
);
export const projectEOLReuseListFailure = createAction(
  '[Projects/API] projectEOLReuseList failure',
  props<{ error: any }>()
);
// For Project ->Eol consumer
export const projectEOLConsumerist = createAction(
  '[Projects/API] projectEOLConsumerist',
  props<{ payload: any; scenarioId: any }>()
);
export const projectEOLConsumeristSuccess = createAction(
  '[Projects/API] projectEOLConsumerist success',
  props<{ eolConsumerList: any }>()
);
export const projectEOLConsumeristFailure = createAction(
  '[Projects/API] projectEOLConsumerist failure',
  props<{ error: any }>()
);

// for opening add/edit eol pre retail
export const openAddEditEolPreRetail = createAction(
  '[Projects/API] Open Add edit pre retail Modal',
  props<{
    scenarioId: string;
    reuseFillingId: string;
    actionLabel: string;
    pathName: any;
    storagetypeId: number;
    reuseType?: any;
  }>()
);
export const openAddEditEolPreRetailSuccess = createAction(
  '[Projects/API] Open Add edit edit pre retail Modal success',
  props<{ eolPreRetailData: any }>()
);
export const ClearAddEditPreReatailModal = createAction(
  '[Projects/API] Clear edit pre retail Modal'
);

export const clearEolPreReatil = createAction(
  '[Projects/API] Clear edit pre retail all data',
  props<{ resetText: any }>()
);
export const clearPreRetailReuseActionList = createAction(
  '[Projects/API] clearPreRetailReuseActionList'
);
//Transport pre retail reuse
export const preRetailReuseAction = createAction(
  '[Projects/API] preRetailReuseAction',
  props<{ transport: any; action: any; ingredientIndex?: any }>()
);
export const preRetailReuseActionSuccess = createAction(
  '[Projects/API] preRetailReuseAction Success',
  props<{ preRetailReuseActionList: any; dupliatePreRetailActionList: any }>()
);
export const preRetailReuseSetData = createAction(
  '[Projects/API] preRetailReuseAction Set Data',
  props<{ preRetailReuseActionList: any; transportId: any; transportData: any }>()
);

//Transport pre retail manudal location
export const manudaLocationPreRetail = createAction(
  '[Projects/API] manudaLocationPreRetail',
  props<{ transport: any; action: any; ingredientIndex?: any }>()
);
export const manudaLocationPreRetailSuccess = createAction(
  '[Projects/API] manudaLocationPreRetail Success',
  props<{
    transportScenarioManualLocationList: any;
    duplicateManualLocation: any;
    error: any;
    distanceError: string;
  }>()
);

// Transport pre retail manual distance
export const manudaDistancePreRetail = createAction(
  '[Projects/API] manudaDistancePreRetail',
  props<{ transport: any; action: any; ingredientIndex?: any }>()
);
export const manudaDistancePreRetailSuccess = createAction(
  '[Projects/API] manudaDistancePreRetailSuccess Success',
  props<{ transportScenarioManualDistanceList: any; duplicateManualDistance: any; error: any }>()
);

// actions for adding component in project filling
export const eolPreRetailAddComponent = createAction(
  '[Projects/API] component pre retail transport process',
  props<{ component: any; action: any; isInline?: boolean; rowIdx?: any }>()
);
export const eolPreRetailAddComponentSuccess = createAction(
  '[Projects/API] component pre retail transport process Success',
  props<{ componentPreRetailList: any; error: any }>()
);
export const clearEolPreRetailAddComponent = createAction(
  '[Projects/API] clear pre retail  transport process'
);

// for add or edit eol pre retail
export const addEditEolPreRetail = createAction(
  '[Projects/API] Add edit pre retail',
  props<{ preEolRetailPayload: any; scenarioId: any; pathName: any }>()
);
export const addEditEolPreRetailSuccess = createAction(
  '[Projects/API] Add edit pre retail success',
  props<{ preEolRetailData: any }>()
);
export const addEditEolPreRetailFailure = createAction(
  '[Projects/API] Add edit pre retail failure',
  props<{ error: any }>()
);

export const addOrgYear = createAction(
  '[Projects/API] ADD organization year',
  props<{ process: any; action: any; processIndex?: any; nodeId?: any; colId?: any }>()
);
export const deleteOrgYear = createAction(
  '[Projects/API] Delete organization year',
  props<{ process: any; processIndex?: any; nodeId?: any; colId?: any }>()
);
export const updateOrgYear = createAction(
  '[Projects/API] Update organization year',
  props<{ process: any; action: any; processIndex?: any; nodeId?: any; colId?: any }>()
);
export const fillOrgYearGridData = createAction(
  '[Projects/API] Fill organization year grid data',
  props<{ data: any }>()
);

// Project Scenario -> Config. -> Org reporting error
export const orgReportingError = createAction(
  '[Projects/API] Project Scenario Config. Organization reporting error',
  props<{ string: any }>()
);

export const clearFillDataComponentErr = createAction(
  '[Projects/API] clear component in fill data error'
);
export const clearFillDataProductErr = createAction(
  '[Projects/API] clear product in fill data error'
);

export const addEolViewModalData = createAction('[Projects/API] ', props<{ EOLviewData: any }>());
export const addEolViewModalDataChange = createAction(
  '[Projects/API reset eol] ',
  props<{ resetEOLviewData: any }>()
);

export const updatePackageEOLRetail = createAction(
  '[Projects/API] Update package EOL retail',
  props<{ process: any; action: any; processIndex?: any; nodeId?: any; colId?: any }>()
);

export const updatePackageEOLConsumer = createAction(
  '[Projects/API] Update package EOL consumer',
  props<{ process: any; action: any; processIndex?: any; nodeId?: any; colId?: any }>()
);

export const patchEOLRetailDataOnInit = createAction(
  '[Projects/API] Patch EOL retail list data on init time',
  props<{ data: any }>()
);

export const patchEOLConsumerDataOnInit = createAction(
  '[Projects/API] Patch EOL consumer list data on init time',
  props<{ data: any }>()
);

export const updateProductMixProcess = createAction(
  '[Projects/API] Update product mix process',
  props<{ process: any; action: any; processIndex?: any; nodeId?: any; colId?: any }>()
);
export const updateProductMixProcessSuccess = createAction(
  '[Projects/API] Update product mix process success',
  props<{ productMixProcess: any; error: any }>()
);
export const deleteProductMixProcess = createAction(
  '[Projects/API] Delete product mix process',
  props<{ process: any; action: any; processIndex?: any }>()
);
export const deleteProductMixProcessSuccess = createAction(
  '[Projects/API] Delete product mix process'
);

export const getProductMixList = createAction(
  '[Projects/API] Get and store product mix process list',
  props<{ payload: any }>()
);
export const getProductMixListSuccess = createAction(
  '[Projects/API] Get and store product mix process list success',
  props<{ productMixProcess: any }>()
);
export const clearProductMixList = createAction('[Projects/API] clear product mixture list');
export const clearProductMixError = createAction(
  '[Projects/API] clear product mixture error string once add is successful',
  props<{ errorStr: any }>()
);

export const checkUpdateForProdMix = createAction(
  '[Projects/API] update action fire for Product mix',
  props<{ check: boolean }>()
);
export const checkUpdateActionForOrganizationMapping = createAction(
  '[Projects/API] update action fire for organization data mapping',
  props<{ check: boolean }>()
);
export const checkUpdateActionForInterpretation = createAction(
  '[Projects/API] update action fire for interpratatiom',
  props<{ check: boolean }>()
);
export const checkUpdateActionForIngredient = createAction(
  '[Projects/API] update action fire for ingredient',
  props<{ check: boolean }>()
);

export const fillDataAnalysisListAction = createAction(
  '[Projects/API] Get and store product mix process list success',
  props<{ fillDataAnalysisList: any }>()
);
export const updateTechnologyInDataAnalysis = createAction(
  '[Projects/API] Update technlogy in report interpretation process',
  props<{ process: any; action: any; processIndex?: any; nodeId?: any }>()
);

export const updateComponentErr = createAction(
  '[Projects/API] Update packaging EOL error string',
  props<{ errorStr: string }>()
);
export const clearComponentErr = createAction('[Projects/API] Clear packaging EOL error string');
export const checkUpdateActionForReuse = createAction(
  '[custom/API] update action fire for reuse process',
  props<{ check: boolean }>()
);

//Action for opening add/edit  my project scenario Material List
export const openImportNewAddProjectMaterialModal = createAction(
  '[Projects/API] Open  openImportNewAddProjectMaterialModal',
  props<{
    data?: any;
    scenarioId?: any;
    actionLabel: any;
    isMaterial: boolean;
    id: any;
    pathName: any;
  }>()
);
export const openImportNewAddProjectMaterialModalSuccess = createAction(
  '[Projects/API] Open  openImportNewAddProjectMaterialModalsuccess',
  props<{ openNewAddProjectMaterialModalData?: any }>()
);
